import React from 'react';
import { Award, CheckCircle, AlertTriangle, Download, X, Share2 } from 'lucide-react';

export default function PerformanceReportModal({ isOpen, onClose, metrics }) {
  if (!isOpen) return null;

  const { totalPnL, disciplineScore, tradeCount, winRate = "65%" } = metrics;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(5, 7, 10, 0.85)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#0F172A', border: '1px solid rgba(212, 175, 55, 0.4)',
        borderRadius: '20px', width: '100%', maxWidth: '600px', padding: '35px',
        color: '#FFF', position: 'relative', boxShadow: '0 25px 50px rgba(0,0,0,0.7)',
        animation: 'fadeIn 0.3s ease-out'
      }}>
        
        {/* Close Button */}
        <button onClick={onClose} style={{
          position: 'absolute', top: '20px', right: '20px',
          background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer'
        }}>
          <X size={22} />
        </button>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ display: 'inline-flex', padding: '10px', backgroundColor: 'rgba(212, 175, 55, 0.15)', borderRadius: '50%', color: '#D4AF37', marginBottom: '12px' }}>
            <Award size={32} />
          </div>
          <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '24px', color: '#D4AF37', margin: '0 0 5px 0' }}>
            Vyodha Post-Market AI Report Card
          </h2>
          <p style={{ color: '#94A3B8', fontSize: '13px', margin: 0 }}>Official Institutional Trading Performance & Psychology Audit</p>
        </div>

        {/* Key Metrics Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px', marginBottom: '25px' }}>
          
          <div style={{ backgroundColor: '#1E293B', padding: '18px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <span style={{ fontSize: '12px', color: '#94A3B8', display: 'block', marginBottom: '5px' }}>Net Realized P&L</span>
            <strong style={{ fontSize: '22px', color: totalPnL >= 0 ? '#10B981' : '#EF4444' }}>
              {totalPnL >= 0 ? '+' : ''}₹ {totalPnL.toFixed(2)}
            </strong>
          </div>

          <div style={{ backgroundColor: '#1E293B', padding: '18px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <span style={{ fontSize: '12px', color: '#94A3B8', display: 'block', marginBottom: '5px' }}>Discipline Score</span>
            <strong style={{ fontSize: '22px', color: disciplineScore > 75 ? '#10B981' : '#F59E0B' }}>
              {disciplineScore} / 100
            </strong>
          </div>

          <div style={{ backgroundColor: '#1E293B', padding: '18px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <span style={{ fontSize: '12px', color: '#94A3B8', display: 'block', marginBottom: '5px' }}>Total Trades</span>
            <strong style={{ fontSize: '20px', color: '#FFF' }}>{tradeCount} Sessions</strong>
          </div>

          <div style={{ backgroundColor: '#1E293B', padding: '18px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)' }}>
            <span style={{ fontSize: '12px', color: '#94A3B8', display: 'block', marginBottom: '5px' }}>Execution Win Rate</span>
            <strong style={{ fontSize: '20px', color: '#38BDF8' }}>{winRate}</strong>
          </div>

        </div>

        {/* AI Psychologist Verdict */}
        <div style={{ backgroundColor: 'rgba(212, 175, 55, 0.08)', border: '1px solid rgba(212, 175, 55, 0.2)', padding: '18px', borderRadius: '12px', marginBottom: '30px' }}>
          <h4 style={{ color: '#D4AF37', fontSize: '14px', margin: '0 0 6px 0', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <CheckCircle size={16} /> AI Risk Coach Verdict
          </h4>
          <p style={{ color: '#CBD5E1', fontSize: '13px', margin: 0, lineHeight: '1.5' }}>
            {disciplineScore >= 75 
              ? "Phenomenal discipline! Your risk-to-reward ratio and stop-loss adherence matched top-tier prop firm standards today." 
              : "Warning: High frequency or missing stop-losses detected. Ensure strict adherence to predefined risk limits in upcoming sessions."}
          </p>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '15px' }}>
          <button onClick={() => alert("Report card downloaded successfully as PDF!")} style={{
            flex: 1, backgroundColor: '#D4AF37', color: '#000', border: 'none',
            padding: '14px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
          }}>
            <Download size={18} /> Download PDF Report
          </button>
          
          <button onClick={() => alert("Report copied! Ready to share on Telegram/Instagram channels.")} style={{
            backgroundColor: '#1E293B', color: '#FFF', border: '1px solid rgba(255,255,255,0.2)',
            padding: '14px 20px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
          }}>
            <Share2 size={18} /> Share
          </button>
        </div>

      </div>
    </div>
  );
}